import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfirmDialog } from "./components/confirm-dialog/confirm-dialog.component";
import { HtmlContentDialogComponent } from "./components/html-content-dialog/html-content-dialog.component";
import { UnderConstructionComponent } from "./components/under-construction/under-construction.component";

import { SnackBarService } from "./services/snack-bar.service";

import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { LogTypeIconComponent } from "./components/log-type-icon/log-type-icon.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LogFieldComponent } from "./components/log-field/log-field.component";
import { ItemAuthorComponent } from "./components/item/item-author/item-author.component";
import { AuthorCreateUpdateDialogModule } from "./components/author/create-update-dialog/author-create-update-dialog.module";
import { ContactCreateUpdateDialogModule } from "./components/contact/create-update-dialog/contact-create-update-dialog.module";
import { FlagModule } from "./components/flag/flag.module";
import { ItemsQuickListModule } from "./components/item/quick-list/items-quick-list.module";
import { SharedPipesModule } from "./pipes/shared-pipes.module";
import { ItemInventoryCodeModule } from "./components/item/item-inventory-code/item-inventory-code.module";
import { AuctionCreateUpdateDialogModule } from "./components/auctions/create-update-dialog/auction-create-update-dialog.module";
import { ItemPreviewModule } from "./components/item/item-preview/item-preview.module";
import { LightboxModule } from "./components/lightbox/lightbox.module";
import { PublicationCreateUpdateDialogModule } from "./components/publications/publication-create-update-dialog/publication-create-update-dialog.module";
import { ExhibitionCreateUpdateDialogModule } from "./components/exhibitions/create-update-dialog/exhibition-create-update-dialog.module";

@NgModule({
  declarations: [
    ConfirmDialog,
    HtmlContentDialogComponent,
    UnderConstructionComponent,
    LogTypeIconComponent,
    LogFieldComponent,
    ItemAuthorComponent,
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatSnackBarModule,
    MatTooltipModule,
    AuthorCreateUpdateDialogModule,
    AuctionCreateUpdateDialogModule,
    ContactCreateUpdateDialogModule,
    PublicationCreateUpdateDialogModule,
    ExhibitionCreateUpdateDialogModule,
    FlagModule,
    LightboxModule,
    ItemsQuickListModule,
    SharedPipesModule,
    ItemInventoryCodeModule,
    ItemPreviewModule,
  ],
  exports: [
    ConfirmDialog,
    HtmlContentDialogComponent,
    UnderConstructionComponent,
    LogTypeIconComponent,
    LogFieldComponent,
  ],
  providers: [SnackBarService],
})
export class SharedModule {}
